import { GlassCard } from '@/components/ui/GlassCard'
import { Cpu, Shield, BarChart3, Zap, LucideIcon } from 'lucide-react'
import { useT } from '@/i18n/provider'

const ICON_MAP: Record<string, LucideIcon> = {
  Cpu, Shield, BarChart3, Zap,
}

export function FeaturesSection() {
  const t = useT()
  const features = [
    { icon: 'Cpu', title: t('landing.features.multiProviderTitle'), description: t('landing.features.multiProviderDescription') },
    { icon: 'Shield', title: t('landing.features.secureTitle'), description: t('landing.features.secureDescription') },
    { icon: 'BarChart3', title: t('landing.features.analyticsTitle'), description: t('landing.features.analyticsDescription') },
    { icon: 'Zap', title: t('landing.features.chatTitle'), description: t('landing.features.chatDescription') },
  ]

  return (
    <section className="relative z-10 py-24 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-16 space-y-3">
          <p className="text-xs font-semibold uppercase tracking-widest text-[var(--oc-accent-light)]">
            {t('landing.features.eyebrow')}
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-white">
            {t('landing.features.title')}
          </h2>
          <p className="text-white/50 max-w-xl mx-auto">
            {t('landing.features.subtitle')}
          </p>
        </div>

        {/* Feature cards grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {features.map((feature) => {
            const Icon = ICON_MAP[feature.icon] ?? Zap
            return (
              <GlassCard key={feature.title} hover className="space-y-4 group">
                <div className="w-10 h-10 rounded-xl bg-[var(--oc-accent)]/20 border border-[var(--oc-accent)]/30 flex items-center justify-center group-hover:bg-[var(--oc-accent)]/30 transition-colors">
                  <Icon size={20} className="text-[var(--oc-accent-light)]" />
                </div>
                <div>
                  <h3 className="font-semibold text-white mb-1">{feature.title}</h3>
                  <p className="text-sm text-white/50 leading-relaxed">{feature.description}</p>
                </div>
              </GlassCard>
            )
          })}
        </div>
      </div>
    </section>
  )
}
